import { render, staticRenderFns } from "./grouping.vue?vue&type=template&id=1272c192&"
import script from "./grouping.vue?vue&type=script&lang=js&"
export * from "./grouping.vue?vue&type=script&lang=js&"
import style0 from "./grouping.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports